export default function ({ route, store, redirect }) {
  const disableSpacePage = store?.state?.base?.meta?.generalConfig?.disableSpacePage || []
  if (disableSpacePage.length === 0) return
  const result = disableSpacePage.some((projectSlug) => route.path.includes(`${projectSlug}/space`))
  if (result) redirect('/')
}
